import { gql } from "@apollo/client"
export const QUERY_ME = gql(`
    query Me {
      me {
        __typename
        id
        firstName
        lastName
        company {
          __typename
          id
          name
          companySubscriptions{
              id
              subscription{
              id
              name
              }
          }
        }
        locations{
          pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
          }
          edges{
              node {
                  id
                  name
                  streetLineOne
                  streetLineTwo
                  city
                  state
                  postalCode
                  country
                  customFields{
                      __typename
                      id
                      type
                      name
                      position    
                  }
              }
          }
        }
        defaultLocation {
          __typename
          id
          name
          streetLineOne
          streetLineTwo
          city
          state
          postalCode
          country
          customFields {
              __typename
              id
              type
              name
              position
          }
        }
      }
    }
      `);
